"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _mobx = require("mobx");

var _mobxReact = require("mobx-react");

var _TextInput = _interopRequireDefault(require("./TextInput"));

var _validators = require("../../toolkit/forms/validators");

var _class, _class2, _class3, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var EmailInput = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(EmailInput, _Component);

  var _super = _createSuper(EmailInput);

  function EmailInput() {
    (0, _classCallCheck2["default"])(this, EmailInput);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(EmailInput, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_TextInput["default"], (0, _extends2["default"])({}, this.props, {
        validators: this.validators
      }));
    }
  }, {
    key: "validators",
    get: function get() {
      var _this$props$validator = this.props.validators,
          validators = _this$props$validator === void 0 ? [] : _this$props$validator;
      return [new _validators.RequiredValidator(), new _validators.EmailValidator()].concat((0, _toConsumableArray2["default"])(validators));
    }
  }]);
  return EmailInput;
}(_react.Component), _class3.propDoc = _TextInput["default"].propDoc, _class3.discussion = "\n  This component wraps [`TextInput`](/lego/component/TextInput) with some validators for emails.\n  ", _class3.demoProps = {
  placeholder: "please enter your email",
  onChange: function onChange() {}
}, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "validators", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "validators"), _class2.prototype)), _class2)) || _class;

var _default = EmailInput;
exports["default"] = _default;